import Breadcrumb from "../Component/Breadcrumb"
import Footer from "../Component/Footer"
import Header from "../Component/Header"

const HelpStudy = () => {
    return (
        <>
            <Header />
            <Breadcrumb title="Helps to Study" midBreadcrumb="Academic" mainBreadcrumb="Helps to Study" ></Breadcrumb>
            <div className='inner-page'>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h2 className="mainhead">Helps to Study</h2>
                            <h3 className="subhead">General Hints</h3>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/help-study.gif" className="img-fluid mx-auto d-block mb-3" alt="matamariamjansevavidyalayas" />
                            <div className="media">
                                <div className="media-body">
                                    <p><strong>01.</strong> Take up first the subject you most dislike; once you have done this, rest of your
                                        work will be easy.</p>
                                </div>
                            </div>
                            <div className="media">
                                <div className="media-body">
                                    <p><strong>02.</strong>Do not hesitate to ask your teachers or your cleverer companion’s things you do not
                                        grasp clearly. Never leave difficulties unanswered as this will put you into greater difficulties later.
                                    </p>
                                </div>
                            </div>
                            <div className="media">
                                <div className="media-body">
                                    <p><strong>03.</strong> To make sure that you have
                                        understood something thoroughly, use these tricks. </p>
                                    <ul className="list">
                                        <li>Pretend that you are explaining the lesson to another;
                                            see if you can do it well.</li>
                                        <li>Make yourself your own teacher and question yourself
                                            and answer honestly. (Don’t cheat.)</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="media">
                                <div className="media-body">
                                    <p><strong>03.</strong> Do not continue working when you are tired; walk around the garden, or talk to a
                                        friend or have some other pleasant interruption, but only long enough to refresh. You finish your
                                        lessons and not tend to waste time.</p>
                                </div>
                            </div>
                            <div className="media">
                                <div className="media-body">
                                    <p><strong>04.</strong>Get enough exercise every day; it keeps the mind fresh.</p>
                                </div>
                            </div>
                            <div className="media">
                                <div className="media-body">
                                    <p><strong>05.</strong>Do not cut down necessary sleep in order to study; it will hurt you later on.</p>
                                </div>
                            </div>
                            <div className="media">
                                <div className="media-body">
                                    <p><strong>06.</strong> Lastly, pray often to the all wise and all-knowing God to help you make progress
                                        in your studies.</p>
                                </div>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default HelpStudy